<template>
  <header
    class="menu-topo"
    :class="{ 'menu-scrolled': scrolled, 'menu-hidden': hidden }"
  >
    <div class="flag desktop-only">
      <img
        class="flag-icon cursor-pointer"
        src="@/assets/flag-us.png"
        alt="Bandeira US"
        @click="setIdioma('en')"
      />
      <img
        class="flag-icon cursor-pointer"
        src="@/assets/flag-brasil.png"
        alt="Bandeira Brasil"
        @click="setIdioma('pt')"
      />
    </div>

    <nav class="menu">
      <a href="/">
        <img class="logo" src="@/assets/logo.png" alt="logo egroup" />
      </a>

      <!-- BOTÃO HAMBURGUER (mobile) -->
      <button
        class="hamburger"
        :class="{ open: mobileOpen }"
        @click="mobileOpen = !mobileOpen"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <!-- MENU -->
      <ul :class="{ open: mobileOpen }">
        <li>
          <router-link to="/" @click.native="closeMobile">Home</router-link>
        </li>

        <li>
          <router-link to="/alliances" @click.native="closeMobile"
            >Alliance</router-link
          >
        </li>

        <li>
          <router-link to="/solutions" @click.native="closeMobile"
            >Solutions</router-link
          >
        </li>

        <li>
          <router-link to="/travel" @click.native="closeMobile"
            >Travel</router-link
          >
        </li>

        <li>
          <router-link
            class="btn-hospedese"
            to="/alliances"
            @click.native="closeMobile"
          >
            Explore
          </router-link>
        </li>

        <!-- ✅ FLAGS DENTRO DO MENU MOBILE -->
        <li class="flag-mobile">
          <img
            src="@/assets/flag-us.png"
            alt="US"
            @click="
              setIdioma('en');
              closeMobile();
            "
          />
          <img
            src="@/assets/flag-brasil.png"
            alt="BR"
            @click="
              setIdioma('pt');
              closeMobile();
            "
          />
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  name: "TheHeader",
  data() {
    return {
      scrolled: false,
      hidden: false,
      lastScroll: 0,
      mobileOpen: false,
    };
  },
  watch: {
    $route(to) {
      // Se a rota não for 'home', ativa o fundo branco
      this.scrolled = to.name !== "home";
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    // Define inicialmente baseado na rota atual
    this.scrolled = this.$route.name !== "home";

    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    closeMobile() {
      this.mobileOpen = false;
    },
    handleScroll() {
      if (this.mobileOpen) return; // NÃO some se menu estiver aberto
      const currentScroll = window.scrollY;

      // Na home: adiciona fundo branco ao descer 30px
      // Nas outras páginas: sempre tem fundo branco
      if (this.$route.name === "home") {
        this.scrolled = currentScroll > 30;
      }

      // verifica direção do scroll
      if (currentScroll > this.lastScroll && currentScroll > 100) {
        // rolando pra baixo → esconder
        this.hidden = true;
      } else {
        // rolando pra cima → mostrar
        this.hidden = false;
      }

      this.lastScroll = currentScroll;
    },
    setIdioma(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("idioma", lang);
    },
  },
  computed: {
    nome() {
      return this.$store.state.usuario.nome.replace(/ .*/, "");
    },
  },
};
</script>

<style scoped>
.menu-topo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%; /* agora cobre toda a tela */
  z-index: 100;
  transition: background 0.3s ease, box-shadow 0.3s ease, transform 0.4s ease;
  background: transparent;
}

/* Quando rolar: fundo branco + sombra */
.menu-topo.menu-scrolled {
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

/* Quando rolar pra baixo → sumir */
.menu-topo.menu-hidden {
  transform: translateY(-100%);
}

.menu,
.flag {
  max-width: 1360px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
}

.menu ul {
  display: flex;
  gap: 20px;
  align-items: center;
}

.menu ul li {
  text-transform: uppercase;
  font-size: 1.1rem;
  font-weight: 500;
  color: #081e35;
}

.menu ul li a {
  text-transform: uppercase;
  font-size: 1.1rem;
  font-weight: 500 !important;
  color: #081e35;
}

/* Logo */
.logo {
  width: 160px;
}

/* Botão Hospede-se */
.btn-hospedese {
  padding: 12px 24px;
  background: #081e35;
  color: #fff !important;
  border-radius: 4px;
}

/* Flags */
.flag {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 8px 0;
}

.flag-icon {
  width: 32px;
}

/* Router Link ativo */
.router-link-exact-active {
  position: relative;
  padding-bottom: 10px;
}

.router-link-exact-active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  background: #123050;
  border-radius: 2px;
}

.hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
}

.hamburger span {
  width: 26px;
  height: 3px;
  background: #081e35;
  border-radius: 3px;
  transition: 0.3s;
}

/* animação X */
.hamburger.open span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}
.hamburger.open span:nth-child(2) {
  opacity: 0;
}
.hamburger.open span:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
}

.desktop-only {
  display: flex;
}
.flag-mobile {
  display: none;
}

@media (max-width: 640px) {
  .menu-topo {
    max-width: 100vw;
  }

  /* header não some no scroll no mobile */
  .menu-topo.menu-hidden {
    transform: none;
  }

  /* some flags do topo */
  .desktop-only {
    display: none !important;
  }

  /* flags dentro do menu */
  .flag-mobile {
    display: flex;
    gap: 16px;
    margin-top: 20px;
  }

  .flag-mobile img {
    width: 36px;
    cursor: pointer;
  }

  .flag {
    position: fixed;
    top: env(safe-area-inset-top, 12px);
    left: 50%;
    transform: translateX(-50%);
    width: auto;
    max-width: none;
    margin: 0;
    padding: 6px;
    display: flex;
    align-items: center;
    gap: 12px;

    z-index: 1000; /* acima do hero */
  }

  /* menu principal */
  .menu {
    flex-direction: row;
    padding: 8px 16px;
  }

  /* LOGO */
  .logo {
    width: 120px;
  }

  /* ✅ MOSTRA HAMBURGER */
  .hamburger {
    display: flex;
  }

  /* ❌ ESCONDE MENU DESKTOP */
  .menu ul {
    display: none;
  }

  /* ✅ MENU MOBILE OVERLAY */
  .menu ul.open {
    display: flex;
    position: fixed;
    top: 72px; /* altura do header */
    left: 0;
    width: 100%;
    background: #fff;

    flex-direction: column;
    align-items: center;
    gap: 20px;

    padding: 24px 0;

    z-index: 999;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
  }

  .menu ul li a {
    font-size: 0.95rem;
  }

  .btn-hospedese {
    width: 90%;
    text-align: center;
  }
}

@media (min-width: 641px) and (max-width: 1023px) {
  /* header mantém layout horizontal */
  .menu {
    padding: 0 24px 10px;
  }

  .logo {
    width: 140px;
  }

  .menu ul {
    gap: 14px;
  }

  .menu ul li,
  .menu ul li a {
    font-size: 0.95rem;
  }

  .btn-hospedese {
    padding: 10px 18px;
  }
}
</style>
